import { requiredSIPForTarget } from "../../engine/calculations";

const config = {
  key: "req-sip-cost-of-delay",
  title: "SIP Required For Target FV (Cost of Delay)",
  category: "Target-Based",
  description: "See how much more you'll need to invest each month for every year you delay starting.",
  fields: [
    { key: "targetFV", label: "Target future value", type: "currency", default: 50_00_000, min: 1000, max: 100_00_00_000 },
    { key: "returnRate", label: "Expected annual return", type: "percent", default: 12, min: 1, max: 30, assumptionKey: "equityReturn" },
    { key: "years", label: "Years to target (if you start now)", type: "number", default: 15, min: 1, max: 40 },
    { key: "delayYears", label: "Years you might delay starting", type: "number", default: 3, min: 0, max: 39, help: "Must be less than the years to target." },
  ],
  chart: {
    type: "bar",
    xKey: "name",
    series: [{ key: "amount", label: "Monthly SIP", colorVar: "--gold" }],
  },
  compute(values) {
    const targetFV = Number(values.targetFV) || 0;
    const annualRate = (Number(values.returnRate) || 0) / 100;
    const years = Number(values.years) || 0;
    const delayYears = Math.min(Number(values.delayYears) || 0, Math.max(years - 1, 0));

    const sipIfNow = requiredSIPForTarget(targetFV, annualRate, years * 12);
    const remainingYears = Math.max(years - delayYears, 1 / 12);
    const sipIfDelayed = requiredSIPForTarget(targetFV, annualRate, remainingYears * 12);
    const extraMonthlySip = sipIfDelayed - sipIfNow;

    return {
      headline: { label: "Extra monthly SIP if you delay", value: extraMonthlySip },
      extraHeadlines: [
        { label: "SIP if you start now", value: sipIfNow },
        { label: `SIP if you start in ${delayYears}y`, value: sipIfDelayed },
      ],
      breakdown: [
        { label: "Years left if you start now", value: years, format: "text" },
        { label: "Years left if you delay", value: Math.round(remainingYears * 10) / 10, format: "text" },
      ],
      series: [
        { name: "Start now", amount: sipIfNow },
        { name: `Delay ${delayYears}y`, amount: sipIfDelayed },
      ],
    };
  },
};

export default config;
